import { createAction, props } from '@ngrx/store';

import { EnvironmentState } from './environment.state';

export const seEnvironmentSet = createAction('[Se] EnvironmentSet', props<{ env: Partial<EnvironmentState> }>());
